import Phone from './phone_v2';
export default Phone;
